const leaves = [
  { image: require("./Leaf 2.png") },
  { image: require("./Leaf 3.png") },
  { image: require("./Leaf 4.png") },
  { image: require("./Leaf 5.png") },
  { image: require("./Leaf 6.png") },
];

export { leaves };
